<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" @close="close" class="w-[950px]">
    <div ref="sizingTableDialog"></div>
  </AtomsGlobalDialog>
</template>
<script setup>

const dialog = computed(() => useDialog().get('sizingTable'));

const i18n = useI18n();

const sizingTableDialog = ref(null);
const sizingData = computed(() => dialog.value?.data?.sizingData);

watch(() => dialog.value?.isOpen, () => {
  if (dialog.value?.isOpen) {
    if (sizingData.value) {
      SizingTable();
    }
  }
});

const close = () => {
  useDialog().close();
  setTimeout(() => SizingTableClose(), 300);
}

function SizingTable() {

  var blockDiv = document.createElement('div');
  blockDiv.id = "sizing-table-dialog";
  blockDiv.className = "over";

  var dialogDiv = document.createElement('div');
  dialogDiv.className = "dialog";

  /// Closer ///
  var dialogClose = document.createElement('div');
  dialogClose.className = "close";

  /// Header ///
  var headerDiv = document.createElement('div');
  headerDiv.className = "mb-8 pb-8 px-8 uppercase font-bold text-2xl border-b border-neutral-200";
  headerDiv.textContent = i18n.t('Tabulka velikostí');

  /// Content ///
  var contentDiv = document.createElement('div');
  contentDiv.className = "desktop:flex gap-6";

  // Content - image
  var myLetter = "A";
  var header = "";
  switch (sizingData.value.img) {
    case "body":
      header = i18n.t('Top');
      myLetter = "A";
      break;
    case "belt":
      header = i18n.t('Opasek');
      myLetter = "A";
      break;
    case "trowsers":
      header = i18n.t('Kalhoty');
      myLetter = "D";
      break;
    case "head":
      header = i18n.t('Čepice / kšiltovky');
      myLetter = "D";
      break;
    case "hands":
      header = i18n.t('Rukavice');
      myLetter = "G";
      break;
    case "shoes":
      header = i18n.t('Obuv');
      myLetter = "F";
      break;
    case "shorts":
      header = i18n.t('Kraťasy');
      myLetter = "D";
      break;
    case "shin":
      header = i18n.t('Holeňové návleky');
      myLetter = "G";
      break;
    case "trowjack":
      header = i18n.t('Kalhoty a bundy');
      myLetter = "A";
      break;
  }
  headerDiv.innerHTML += ' - <span class="text-primary-500">' + header + '</span>';

  var imageDiv = document.createElement('div');
  imageDiv.className = "image mb-4 flex items-center justify-center w-full bg-neutral-500 desktop:max-w-[250px] desktop:mb-0";

  var imageHeader = document.createElement('div');
  imageHeader.className = "image-header";

  imageDiv.appendChild(imageHeader);

  var image = document.createElement('img');
  image.src = useShopZone().value.staticResourcesRoot + '/img/sizing/new/' + sizingData.value.img + '.png';
  image.onload = SizingTableResize;

  imageDiv.appendChild(image);

  // Content - info
  var infoDiv = document.createElement('div');
  infoDiv.className = "info overflow-hidden";

  // Content - info - tables
  var tables = document.createElement('div');
  tables.className = "tables";
  tables.dataset.myletter = myLetter;
  tables.innerHTML = createTables(1, myLetter);

  bindTableHover();

  // Content - info - note
  var noteHeader = document.createElement('div');
  noteHeader.className = "my-2 font-bold";
  noteHeader.textContent = i18n.t('Jak měřit?');

  var pNote = document.createElement('p');
  pNote.className = "note";
  pNote.innerHTML = sizingData.value.note;

  /// Build dialog ///
  dialogDiv.appendChild(dialogClose);
  dialogDiv.appendChild(headerDiv);

  infoDiv.appendChild(tables);
  infoDiv.appendChild(noteHeader);
  infoDiv.appendChild(pNote);

  contentDiv.appendChild(imageDiv);
  contentDiv.appendChild(infoDiv);
  dialogDiv.appendChild(contentDiv);

  blockDiv.appendChild(dialogDiv);
  sizingTableDialog.value.appendChild(blockDiv);

  /// Events
  //window.addEventListener('resize', SizingTableResize);

  /// Body settings
  useUI().setBodyScrollable(false);

  SizingTableResize();
}

function nextChar(c) {
  return String.fromCharCode(c.charCodeAt(0) + 1);
}

function createTables(num, startLetter) {
  var overDiv = document.createElement('div');

  if (sizingData.value.data.length > 1) {
    for (var i = 0; i < num; i++) {
      var htmlTable = '';
      var columnsCount = sizingData.value.columns.length;
      var myLetter = startLetter;
      var start = Math.ceil(columnsCount / num) * i;
      var end = Math.min(start + Math.ceil(sizingData.value.columns.length / num), sizingData.value.columns.length);

      // Content - info - table - header
      htmlTable += '<tr><th class="row px-4 py-2 uppercase font-normal whitespace-nowrap text-xl text-left text-neutral-50 bg-neutral-500 desktop:py-6">' + i18n.t('Velikost') + '</th>';

      for (var c = start; c < end; c++) {
        htmlTable += '<th class="px-2 text-xl text-center whitespace-nowrap text-neutral-50 bg-neutral-500">' + sizingData.value.columns[c] + '</th>';
      }

      htmlTable += "</tr>";

      // Content - info - table - rows
      var l = 0;
      for (var r = 0; r < sizingData.value.rows.length; r++) {
        htmlTable += "<tr>";
        htmlTable += '<th class="row px-4 py-2 border-b border-neutral-200 uppercase font-normal whitespace-nowrap text-left desktop:py-6"><span class="inline-flex items-center justify-center w-8 mr-4 aspect-square text-neutral-50 bg-secondary-500 rounded-full text-lg font-bold">' + myLetter + '</span>' + sizingData.value.rows[r] + '</th>';
        for (var c = start; c < end; c++) {
          htmlTable += '<td class="min-w-[50px] text-center whitespace-nowrap border-b border-neutral-200">' + sizingData.value.data[(l * columnsCount) + c] + '</td>';
        }
        htmlTable += "</tr>";
        myLetter = nextChar(myLetter);
        l++;
      }

      var table = document.createElement('table');
      table.innerHTML = htmlTable;
      table.className = "w-full mb-6";

      overDiv.appendChild(table);
    }
  }

  return overDiv.outerHTML;
}

function bindTableHover() {
  var tableCells = document.querySelectorAll("#sizing-table-dialog table td, #sizing-table-dialog table th");

  tableCells.forEach(function (cell) {
    cell.addEventListener('mouseover', function () {
      var t = Array.prototype.indexOf.call(cell.parentNode.children, cell) + 1;
      if (t != 1) {
        cell.closest('table').querySelectorAll('td:nth-child(' + t + '), th:nth-child(' + t + ')').forEach(function (el) {
          el.classList.add('bg-neutral-100');
        });
      }
    });

    cell.addEventListener('mouseout', function () {
      var t = Array.prototype.indexOf.call(cell.parentNode.children, cell) + 1;
      cell.closest('table').querySelectorAll('td:nth-child(' + t + '), th:nth-child(' + t + ')').forEach(function (el) {
        el.classList.remove('bg-neutral-100');
      });
    });
  });
}

var ww;

if (process.client) {
  ww = window.innerWidth;
}

function SizingTableResize() {

  var wwn = window.innerWidth;
  var tables = document.querySelector("#sizing-table-dialog .dialog .info .tables");

  // Table overflow
  var info = document.querySelector("#sizing-table-dialog .dialog .info");
  var table = document.querySelectorAll("#sizing-table-dialog .dialog .info table");
  var infWidth = info.offsetWidth;

  var recreateTables = false;

  Array.from(table).forEach(function (t) {
    var tWidth = t.offsetWidth;
    if (tWidth > infWidth) {
      tables.innerHTML = createTables(table.length + 1, tables.dataset.myletter);
      recreateTables = true;
      return false;
    }
  });

  if (recreateTables) {
    window.dispatchEvent(new Event('resize'));
    return;
  }
  else {
    if (ww < wwn || (ww >= 1000 && wwn < 1000)) {
      tables.innerHTML = createTables(1, tables.dataset.myletter);
      ww = window.innerWidth;
      window.dispatchEvent(new Event('resize'));
      return;
    }
  }

  bindTableHover();

  ww = wwn;
}

function SizingTableClose() {

  useUI().setBodyScrollable(true);

  var sizingTableDialog = document.getElementById("sizing-table-dialog");
  if (sizingTableDialog) {
    sizingTableDialog.remove();
  }
  window.removeEventListener('resize', SizingTableResize);
}

</script>